import React from 'react';
import {LoadingPageSpinner} from '@aboutyou/ui-components';
import {lazy} from '@aboutyou/lazy-imports';

export const ArticlePage = lazy(
  () => import('./ArticlePage.eager').then(mod => ({default: mod.ArticlePage})),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
  },
);
